export default __webpack_public_path__ + "static/media/Harness of Vicious Frenzy.988f8a63.jpg";